//
import { mapActions, mapGetters, mapState } from 'vuex'

//
import { RAppDrawer } from '@/components/reusable_components/drawers'
import { RAppToolbar } from '@/components/reusable_components/toolbars'
import RAuthBox from '@/components/reusable_components/SessionBox/SessionBox'
import SnackbarModal from '@/components/reusable_components/SnackbarModal/SnackbarModal'

//
import { getAndSaveLoginToken } from '@/services/auth/AuthService'

//
export default {
    name: 'app-component',
    components: {
        RAppDrawer,
        RAppToolbar,
        RAuthBox,
        SnackbarModal,
    },
    computed: {
        //
        ...mapGetters('AuthModule', ['isAuthenticated']),

        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('MenuesModule', ['menues', 'titleTopBar', 'items']),

        /**
         *
         */
        authProps() {
            return {
                colorIconBtn: 'success',
                infoSession: {
                    title: [
                        this.user.hr_employee.names,
                        this.user.hr_employee.last_name1,
                    ].join(' '),
                    subtitle: [
                        'Sucursal: ' +
                            this.user.hr_employee.g_branch_office.name,
                    ],
                },
            }
        },

        /**
         *
         */
        drawerProps() {
            return {
                items: this.menuItemsMapped,
            }
        },

        /**
         *
         */
        menuItemsMapped() {
            return Array.isArray(this.menues)
                ? [...(this.menues || [])].map(this.mapMenu)
                : Object.values(this.menues || {}).map(this.mapMenu)
        },

        /**
         *
         */
        toolbarProps() {
            return {
                title: this.titleTopBar,
                withScroll: !this.drawer,
            }
        },
    },
    data() {
        return {
            drawer: false,
        }
    },
    methods: {
        //
        ...mapActions('AuthModule', {
            authLogout: 'logoutRequestAction',
            goToMenu: 'goToMenu',
        }),

        //
        ...mapActions('MenuesModule', {
            fetchMenues: 'fetchMenues',
            setItemsTopBar: 'setItemsTopBar',
        }),

        //
        ...mapActions('SnackbarModal', {
            setSnackbar: 'setSnackbar',
        }),

        /**
         * show error fetch user toast
         */
        error() {
            //this.$toast.error( "Error al obtener el usuario." )
        },

        /**
         * fetch current user by token in route params
         */
        fetch() {
            getAndSaveLoginToken() //.then( this.success ).catch( this.error )
        },

        /**
         *
         */
        logout() {
            this.authLogout().then(() => {
                window.location.reload()
            })
        },

        /**
         *
         */
        mapMenu(item) {
            return {
                icon: this.menuIcons[item.name] || item.icon,
                href: item.route,
                text: item.name,
                data: [...(item.g_submenus || [])].map(this.mapMenu),
            }
        },

        /**
         * show success fetch user toast
         */
        success() {
            //this.$toast.success( "Bienvenido." )
        },

        /**
         *
         */
        toggleDrawer() {
            this.drawer = !this.drawer
        },
    },
    watch: {
        /**
         *
         */
        $route() {
            this.drawer = false
            this.setItemsTopBar([])
        },
    },
    created() {
        //
        this.menuIcons = {
            'Solicitudes pendientes': 'inbox',
            'Cotizaciones de Compra': 'insert_drive_file',
            Proveedores: 'local_shipping',
            'Órdenes de Compra': 'description',
            // "Productos": "category",
            Facturas: 'money',
            Histórico: 'today',
        }

        // verify if has login user
        if (this.isAuthenticated) {
            // show a welcome message
            //this.$toast.success( "Bienvenido." )
        } else {
            // show requesting message
            //this.$toast.info( "Consultando datos..." )

            // fetch user by param token
            this.fetch()
        }

        //
        this.fetchMenues(5)
    },
}
